import React from 'react';
import { useTranslation } from 'react-i18next';
import './other-information.component.scss';

interface OtherInformationProps {
    otherInfo: string;
    confirmAccurate: boolean;
    onOtherInfoChange: (value: string) => void;
    onConfirmAccurateChange: (value: boolean) => void;
    otherInfoError?: string;
}

export const OtherInformation: React.FC<OtherInformationProps> = ({
    otherInfo,
    confirmAccurate,
    onOtherInfoChange,
    onConfirmAccurateChange,
    otherInfoError
}) => {
    const { t } = useTranslation();

    return (
        <div className="other-information">
            <div className="other-information__header">
                <div className="ec-shead">
                    <span className="ec-sico" aria-hidden="true">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M15.5 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h11l5-5V5a2 2 0 0 0-2-2z" /><path d="M15 3v4a2 2 0 0 0 2 2h4" />
                        </svg>
                    </span>
                    <div className="ec-stext">
                        <h3 className="other-information__title">
                            {t('Other information')}
                        </h3>
                        <p className="ec-sdesc">{t('Add any additional notes for this certificate', { defaultValue: 'Add any additional notes for this certificate' })}</p>
                    </div>
                </div>
            </div>
            
            <div className="other-information__body">
                <p className="other-information__description">
                    {t('otherInfoDescription')}
                </p>
                
                <p className="other-information__appendix">
                    {t('seeAppendix')}
                </p>
                
                <textarea
                    className="other-information__textarea"
                    value={otherInfo}
                    onChange={(e) => onOtherInfoChange(e.target.value)}
                    placeholder={t('Type here...')}
                    rows={4}
                />
                
                <div className="other-information__checkboxes">
                    <label className="other-information__checkbox-item">
                        <input
                            type="checkbox"
                            checked={confirmAccurate}
                            onChange={(e) => onConfirmAccurateChange(e.target.checked)}
                        />
                        <span className="other-information__checkbox-label">
                            {t('confirmAccurate')}
                        </span>
                    </label>
                </div>
            </div>
        </div>
    );
};
